import { useState, useEffect, useCallback } from 'react';
import { getCacheStats, clearAllCache } from '../lib/operatorsCache';

interface OperatorsCacheStats {
  totalEntries: number;
  totalOperators: number;
  oldestEntry: Date | null;
}

interface UseOperatorsCacheReturn {
  cacheStats: OperatorsCacheStats | null;
  clearCache: () => Promise<void>;
  refreshStats: () => void;
  isClearing: boolean;
}

/**
 * Hook per gestire la cache persistente degli operatori (IndexedDB)
 */
export function useOperatorsCache(): UseOperatorsCacheReturn {
  const [cacheStats, setCacheStats] = useState<OperatorsCacheStats | null>(null);
  const [isClearing, setIsClearing] = useState(false);

  // Carica statistiche cache
  const refreshStats = useCallback(async () => {
    try {
      const stats = await getCacheStats();
      setCacheStats(stats);
    } catch (error) {
      console.warn('[useOperatorsCache] Errore caricamento stats:', error);
      setCacheStats(null);
    }
  }, []);

  // Carica statistiche iniziali
  useEffect(() => {
    refreshStats();
  }, [refreshStats]);

  // Svuota la cache
  const clearCache = useCallback(async () => {
    setIsClearing(true);
    try {
      await clearAllCache();
      setCacheStats({
        totalEntries: 0,
        totalOperators: 0,
        oldestEntry: null,
      });
      console.log('[useOperatorsCache] Cache svuotata');
    } catch (error) {
      console.error('[useOperatorsCache] Errore svuotamento cache:', error);
    } finally {
      setIsClearing(false);
    }
  }, []);

  return {
    cacheStats,
    clearCache,
    refreshStats,
    isClearing,
  };
}

export default useOperatorsCache;

